var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"localStoreRecharge"},[_c('CopyDesc',{attrs:{"title":_vm.title,"orderList":_vm.orderList,"htmlTag":_vm.htmlTag}}),_c('CopyContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }